import type { ApiSingleResponse } from '@/types/api.config';
import type { BasicInfoContent, DashboardContent } from '@/types/dashboard';
import { api } from '../api.service';

export const dashboardService = {
  getDashboard: (params?: {
    days?: number;
    newsLimit?: number;
    faqLimit?: number;
  }): Promise<ApiSingleResponse<DashboardContent>> => {
    return api.console.get<ApiSingleResponse<DashboardContent>>(
      '/v1/dashboard',
      params
    );
  },

  getBasicInfo: (): Promise<ApiSingleResponse<BasicInfoContent>> => {
    return api.console.get<ApiSingleResponse<BasicInfoContent>>(
      '/v1/dashboard/basicInfo'
    );
  },
};
